// components/RoleSwitchModal.jsx
import React, { useState } from 'react';
import './RoleSwitchModal.css';
import apiService from '../services/api'; 

const RoleSwitchModal = ({ isOpen, onClose, currentRole, onRoleSwitch }) => {
  const [isSwitching, setIsSwitching] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  if (!isOpen) return null;

 const handleRoleSwitch = async (newRole) => {
  // Get clean email from sessionStorage
  let userEmail = sessionStorage.getItem('user_emailId');
  if (userEmail?.startsWith('user_emailId')) {
    userEmail = userEmail.replace('user_emailId', '');
  }
  if (!userEmail) userEmail = sessionStorage.getItem('email');

  if (!userEmail) {
    alert('User email not found. Please log in again.');
    return;
  }

  const endpoint = '/switch-role';
  const payload = {
    email: userEmail.trim().toLowerCase(),
    newRole: newRole  
  };

  try {
    setIsSwitching(true);

    // This uses your existing apiService (handles auth, baseURL, etc.)
    const result = await apiService.putData(endpoint, payload);

    // Success from backend
    if (result.status === 'success') {
      // Update session storage immediately
      sessionStorage.setItem('access_role', newRole);

      // Show success message
      setShowSuccess(true);

      // Auto-refresh page after 2 seconds → role is now visible everywhere
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      alert(result.message || 'Failed to switch role');
    }
  } catch (error) {
    console.error('Role switch failed:', error);
    alert(error.message || 'Network error. Please try again.');
  } finally {
    setIsSwitching(false);
  }
};

  const roles = [
    {
      id: 'manager',
      title: 'Manager',
      description: 'Manage team assessments and reviews',
      icon: (
        <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      isCurrent: currentRole === 'manager'
    },
    {
      id: 'admin',
      title: 'Admin',
      description: 'Full access to all system features',
      icon: (
        <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      isCurrent: currentRole === 'admin'
    }
  ];

  return (
    <div className="role-switch-overlay" onClick={!isSwitching ? onClose : undefined}>
      <div className="role-switch-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="role-switch-header">
          <div className="role-switch-header-content">
            <div className="role-switch-icon-wrapper">
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </div>
            <div>
              <h3>Role Switch</h3>
              <p>Switch between Manager and Admin roles</p>
            </div>
          </div>
          <button 
            className="role-switch-close" 
            onClick={onClose}
            disabled={isSwitching}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="role-switch-body">
          {/* Success Message */}
          {showSuccess && (
            <div className="success-message">
              <div className="success-icon">
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <p className="success-title">Role switched successfully!</p>
                <p className="success-subtitle">Your session has been updated.</p>
              </div>
            </div>
          )}

          {/* Current Role Section */}
          <div className="current-role-section">
            <div className="current-role-label">Current Active Role</div>
            <div className="current-role-card">
              <div className="current-role-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <strong className="current-role-title">
                  {currentRole === 'admin' ? 'ADMIN' : 'MANAGER'}
                </strong>
                <p className="current-role-subtitle">
                  {currentRole === 'admin' 
                    ? 'Full system access' 
                    : 'Team management access'}
                </p>
              </div>
            </div>
          </div>

          {/* Role Options */}
        {/* Role Options – ONLY show the OTHER role */}
<div className="role-options">
  <h4>Select New Role</h4>
  <div className="roles-grid">
    {roles
      .filter(role => !role.isCurrent)   // ← This line removes the current role
      .map((role) => (
        <div
          key={role.id}
          className={`role-option-card ${isSwitching ? 'disabled' : ''}`}
          onClick={() => !isSwitching && handleRoleSwitch(role.id)}
          style={{ cursor: isSwitching ? 'not-allowed' : 'pointer' }}
        >
          <div className="role-option-header">
            <div className="role-option-icon">
              {role.icon}
            </div>
          </div>

          <div className="role-option-info">
            <h5>{role.title}</h5>
            <p>{role.description}</p>
          </div>
        </div>
      ))}
  </div>
</div>

          {/* Loading State */}
          {isSwitching && (
            <div className="loading-message">
              <div className="spinner"></div>
              <p>Switching role...</p>
            </div>
          )}

          {/* Info Note */}
          <div className="role-switch-note">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 16v-4m0-4h.01" />
            </svg>
            <div>
              <p className="note-title">Important Note</p>
              <p className="note-text">
                Switching roles will update your permissions immediately. 
                Some features may become available or restricted based on the selected role.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="role-switch-footer">
          <button 
            className="role-switch-close-btn" 
            onClick={onClose}
            disabled={isSwitching}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSwitchModal;